export const BACKDROP_TRANSITION_DURATION_MS = 200;

export const MODAL_CLOSE_COUNTDOWN_SEC = 12;
